/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { useEffect } from "react";
import { openUrl } from "pdfActionManager";

const verifyOrigin = evt => {
  const { origin, target } = evt;
  if (!target || !target.origin) {
    return false;
  }
  return origin === window.location.origin && target.origin === window.location.origin;
};

const onExternalLinkClicked = evtData => {
  const { url } = evtData;
  openUrl(url, { triggeredFrom: "Liquid Mode view" });
};

const handleDxEvent = evt => {
  if (!verifyOrigin(evt)) {
    return;
  }

  const { data } = evt;
  if (data) {
    const { command } = data;
    switch (command) {
      case "externalLinkClicked":
        onExternalLinkClicked(data);
        break;
      default:
        break;
    }
  }
};

const useDxEventHandler = isDxReady => {
  useEffect(() => {
    if (isDxReady) {
      window.addEventListener("message", handleDxEvent);
    }

    return () => {
      window.removeEventListener("message", handleDxEvent);
    };
  }, [isDxReady]);
};

export default useDxEventHandler;
